import { Transcoder } from '@img-arena/consoles-api-streaming'

import { CheckboxDeleteSelectedItem } from '../CheckboxDeleteSelectedItem/CheckboxDeleteSelectedItem'

interface CheckboxDeleteSelectedTranscoderItemProps {
  onDelete: (items: Transcoder[]) => Promise<void> | void
}

export const CheckboxDeleteSelectedTranscoderItem = ({
  onDelete
}: CheckboxDeleteSelectedTranscoderItemProps) => (
  <CheckboxDeleteSelectedItem
    onDelete={onDelete}
    renderItem={(row) => `${row.id} (${row.ip})`}
    successMessage={(rows) => `${rows.length} Transcoders deleted successfully`}
    errorMessage={(rows) => `Failed to delete ${rows.length} Transcoders`}
    confirmationTitle="Delete Selected Transcoders"
    confirmationMessage="Are you sure you want to delete the following Transcoders? This action cannot be undone."
  />
)
